import {MotorFuelList} from "./MotorFuelList";
import {MotorFuelEdit} from "./MotorFuelEdit";
import {MotorFuelCreate} from "./MotorFuelCreate";

export default {
    list: MotorFuelList,
    create: MotorFuelCreate,
    edit: MotorFuelEdit
};
